/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Align_Right_Center_Justify_Right_PosInputs */

const en_align_right_center_justify_right_pos = /** @type {(inputs: Align_Right_Center_Justify_Right_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Center Justify / Right Position`)
};

const fr_align_right_center_justify_right_pos = /** @type {(inputs: Align_Right_Center_Justify_Right_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Justification Centree / Position Droite`)
};

const de_align_right_center_justify_right_pos = /** @type {(inputs: Align_Right_Center_Justify_Right_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zentriert / Rechtsposition`)
};

const it_align_right_center_justify_right_pos = /** @type {(inputs: Align_Right_Center_Justify_Right_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allineamento al centro / Posizione a destra`)
};

const ru_align_right_center_justify_right_pos = /** @type {(inputs: Align_Right_Center_Justify_Right_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Центрирование / Выравнивание по правому краю`)
};

const es_align_right_center_justify_right_pos = /** @type {(inputs: Align_Right_Center_Justify_Right_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Justificación centrada / Posición derecha`)
};

const zh_cn2_align_right_center_justify_right_pos = /** @type {(inputs: Align_Right_Center_Justify_Right_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`居中对齐/右对齐`)
};

const ja_align_right_center_justify_right_pos = /** @type {(inputs: Align_Right_Center_Justify_Right_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中央揃え / 右揃え`)
};

const hi_align_right_center_justify_right_pos = /** @type {(inputs: Align_Right_Center_Justify_Right_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केंद्र संरेखित करें / दाईं ओर स्थित करें`)
};

const pt_pt2_align_right_center_justify_right_pos = /** @type {(inputs: Align_Right_Center_Justify_Right_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centralizado / Posicionamento à direita`)
};

/**
* | output |
* | --- |
* | "Center Justify / Right Position" |
*
* @param {Align_Right_Center_Justify_Right_PosInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const align_right_center_justify_right_pos = /** @type {((inputs?: Align_Right_Center_Justify_Right_PosInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Align_Right_Center_Justify_Right_PosInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_align_right_center_justify_right_pos(inputs)
	if (locale === "de") return de_align_right_center_justify_right_pos(inputs)
	if (locale === "it") return it_align_right_center_justify_right_pos(inputs)
	if (locale === "ru") return ru_align_right_center_justify_right_pos(inputs)
	if (locale === "es") return es_align_right_center_justify_right_pos(inputs)
	if (locale === "zh-CN") return zh_cn2_align_right_center_justify_right_pos(inputs)
	if (locale === "ja") return ja_align_right_center_justify_right_pos(inputs)
	if (locale === "hi") return hi_align_right_center_justify_right_pos(inputs)
	if (locale === "pt-PT") return pt_pt2_align_right_center_justify_right_pos(inputs)
	return en_align_right_center_justify_right_pos(inputs)
});